import { withTransaction } from '@elastic/apm-rum-react'
import { Callout, Input } from '@hub/shared'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import './cover.page.scoped.scss'

interface CoverPageComponentProps {
  getValidation: (event: any) => any
  onChange: (event: any) => any
  name: string
  loadingSubmit: boolean
}

const CoverPageComponent = ({ getValidation, onChange, name = '', loadingSubmit }: CoverPageComponentProps) => {
  const [t] = useTranslation('coverMediaKitPage')

  useEffect(() => {
    if (getValidation && typeof getValidation === 'function') {
      getValidation(!!name?.length)
    }
  }, [name, getValidation])

  const handleChange = (value: string) => {
    if (onChange && typeof onChange === 'function') {
      onChange(value)
    }
  }

  const handleValidate = (valid: boolean) => {
    if (getValidation && typeof getValidation === 'function') {
      getValidation(valid)
    }
  }

  return (
    <div className="cover-mediakit-page">
      <div className="cover-mediakit-page-middle">
        <h5>{t('title')}</h5>
        <Input
          label={t('text')}
          value={name}
          className="input-cover"
          name="input-cover-text"
          readOnly={loadingSubmit}
          id="input-cover-text"
          onChange={(value: string) => handleChange(value)}
          onValidate={(valid: boolean) => handleValidate(valid)}
          required
        />
      </div>
      <div className="cover-tip-mediakit-page-middle">
        <Callout
          colorIcon="var(--text_color)"
          className="box-shadow m-0"
          backgroundColor="var(--background_secondary)"
          title={t('tip.title')}
          iconFontSize="34px"
          icon={'fa-solid fa-lightbulb-on'}
          smallIconStyle
        >
          {t('tip.text')}
        </Callout>
      </div>
    </div>
  )
}

export default withTransaction('CoverPageComponent', 'component')(CoverPageComponent)
